import angular from 'angular';
import providers from './providers/providers.module';
import interceptors from './interceptors/interceptors.module';
import config from './core.config';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.core', [
    providers,
    interceptors
  ])
  .config(config)
  .name;
